import { useApolloClient } from '@apollo/client';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { useRouter } from 'next/router';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import EirActionModal from '../eir-action-modal/EirActionModal';
import { getDataFromEshopDB, getOperationLogin } from './eirLogin.util';
import LoginFields from './LoginFields';
import { removeLocalStorageWithPrefix, setCode } from '../../hooks/useLocalStorage';
import RootContext from '../../../util/root.context';
import styles from './styles';
import fetchInfo from '../../../util/fetchModalData';
import { setCookie } from '../../hooks/useCookie';
import useRecaptchaV3 from '../../hooks/useRecaptchaV3';

const { publicRuntimeConfig } = getConfig();

const LoginModal = ({
  enable,
  setEnableModal,
  prequal,
  handleAltCta,
  onload,
  setShowSubscriptionModal,
  saveLoginInfo,
  mobile,
  showLoader,
  loaderText,
  setShowLoader,
  onLoadingDisablecta,
  setOnLoadingDisablecta,
  isR6Customer,
  isPrepayCustomer,
  openAccountCheck,
  prequaledFromBanner,
  enableCloseCTA,
  registrationIncompleteModal,
  mfaOtpModal,
  setOtpUUID,
  mfaSuccessModal,
  setUserValue,
  setDelivery,
  // cmsCollectionData,
}) => {
  const { executeRecaptcha } = useRecaptchaV3('eirLogin');
  const recaptchaRef = useRef(null);
  const graphql = useApolloClient();
  const theme = useTheme();
  const router = useRouter();
  const [emailAddress, setemailAddress] = useState('');
  const [userPassword, setUserPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [isApiError, setIsApiError] = useState(false);
  const [disablecta, setDisablecta] = useState(true);
  const [loginTitle, setLoginTitle] = useState('');
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const { state, dispatch } = useContext(RootContext);
  const [load, setLoad] = useState(true);
  const [invalidText, setInvalidText] = useState('');
  const [captchaV2, setCaptchaV2] = useState('');
  const [captchaV2Error, setCaptchaV2Error] = useState(false);
  const [userCredential, setUserCredential] = useState(null);
  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'mw-eir-action-modals-existing-cust-login',
      });

      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  useEffect(() => {
    if (enable) {
      setemailAddress('');
      setUserPassword('');
    }
  }, [enable]);

  useEffect(() => {
    if (Object.keys(cmsCollectionData || {}).length !== 0) {
      if (mobile) {
        setLoginTitle(cmsCollectionData?.attributes?.title);
      } else if (prequal) {
        setLoginTitle(cmsCollectionData?.attributes?.loginModalTitleAfterPrequal);
      } else {
        setLoginTitle(cmsCollectionData?.attributes?.loginModalTitleBeforePrequal);
      }
    }
  }, [cmsCollectionData]);

  useEffect(() => {
    if (Object.keys(cmsCollectionData || {}).length !== 0) {
      if (prequal) {
        setLoginTitle(cmsCollectionData?.attributes?.loginModalTitleAfterPrequal);
      } else {
        setLoginTitle(cmsCollectionData?.attributes?.loginModalTitleBeforePrequal);
      }
    }
  }, [prequal]);
  function handleOnChange(value) {
    if (value == null) {
      setCaptchaV2(null);
      setLoginError('recaptcha error');
      setDisablecta(true);
      setOnLoadingDisablecta(true);
      setShowLoader(false);
      setCaptchaV2Error(!captchaV2Error);
    } else {
      setCaptchaV2Error(!captchaV2Error);
      setCaptchaV2(value);
      setLoginError('');
      setDisablecta(false);
    }
  }

  const handleLoginButton = async () => {
    setShowLoader(true);
    saveLoginInfo({ type: 'LOGIN', payload: { email: emailAddress } });
    setCookie('ION', 'EMAIL_ADDRESS', emailAddress);
    setCode('CO');
    setShowLoader(true);
    const recaptchaV3Token = await executeRecaptcha();
    await getOperationLogin({
      graphql,
      emailAddress,
      userPassword,
      setShowLoader,
      setOnLoadingDisablecta,
      setEnableModal,
      setLoginError,
      setIsApiError,
      onload,
      setShowSubscriptionModal,
      isR6Customer,
      isPrepayCustomer,
      mobile,
      registrationIncompleteModal,
      mfaOtpModal,
      mfaSuccessModal,
      recaptchaV3Token,
      setInvalidText,
      captchaV2,
      captchaV2Error,
      setCaptchaV2Error,
      setDisablecta,
      recaptchaRef,
      userCredential,
      setOtpUUID,
      setDelivery,
    });

    dispatch({ type: 'ENABLE_LOGOUT', payload: true });
    if (state?.displayLogin) {
      localStorage.clear();
      dispatch({ type: 'ENABLE_LOGIN_BUTTON', payload: false });
      dispatch({ type: 'DISPLAY_LOGIN', payload: false });
    }
    // await onload();
  };
  const handleRegisterButton = () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_MYEIR}/register`);
  };

  const handleAlt = () => {
    if (state.displayLogin) {
      setEnableModal(false);
      dispatch({ type: 'DISPLAY_LOGIN', payload: false });
    } else {
      removeLocalStorageWithPrefix('ION_EXISTING_CUSTOMER');
      setEnableModal(false);
      openAccountCheck.enable();
    }
  };

  const handleLoginButtonThroughPass = () => {
    handleLoginButton();
  };
  const closeHandler = () => {
    setEnableModal(false);
  };

  useEffect(() => {
    const fetchDataFromEshopDB = async () => {
      const value = await getDataFromEshopDB('user_credential');
      setUserCredential(value);
    };
    fetchDataFromEshopDB();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={enable}
      enableCloseCTA={enableCloseCTA}
      closeHandler={closeHandler}
      onLoadingDisablecta={onLoadingDisablecta}
      desktopImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
        cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.url || ''
      }`}
      mobileImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
        cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.url || ''
      }`}
      desktopImageAlt={
        cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.alternativeText
      }
      mobileImageAlt={cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.alternativeText}
      desktopCurveImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        cmsCollectionData?.attributes?.desktopCurveImg?.data?.attributes?.url || ''
      }`}
      mobileCurverImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        cmsCollectionData?.attributes?.mobileCurverImg?.data?.attributes?.url || ''
      }`}
      sx={mobile ? styles(theme).MobileClass : styles(theme).BroadbandClass}
      title={loginTitle}
      description={
        <>
          {!mobile && (
            <span
              dangerouslySetInnerHTML={{
                __html: `${
                  cmsCollectionData?.attributes?.firstHalfDescription
                    ? cmsCollectionData?.attributes?.firstHalfDescription
                    : ''
                } 
              ${
                cmsCollectionData?.attributes?.secondHalfDescription
                  ? cmsCollectionData?.attributes?.secondHalfDescription
                  : ''
              }`,
              }}
            />
          )}
          <LoginFields
            emailAddress={emailAddress}
            setemailAddress={setemailAddress}
            setUserValue={setUserValue}
            userPassword={userPassword}
            setUserPassword={setUserPassword}
            loginError={loginError}
            isApiError={isApiError}
            setIsApiError={setIsApiError}
            setDisablecta={setDisablecta}
            setLoginError={setLoginError}
            recaptchaRef={recaptchaRef}
            onLoadingDisablecta={onLoadingDisablecta}
            handleLoginButtonThroughPass={handleLoginButtonThroughPass}
            invalidText={invalidText}
            /* eslint-disable react/jsx-no-bind */
            handleOnChange={handleOnChange}
          />
        </>
      }
      cta={[
        {
          // text: 'Login',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Login',
          type: 'solid',
          showLoader,
          loaderText,
          disable: disablecta,
          action: () => handleLoginButton(),
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
        },
        {
          // text: 'Register',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Register',
          type: 'contained',
          disable: onLoadingDisablecta,
          action: () => handleRegisterButton(),
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
        },
      ]}
      altcta={
        // eslint-disable-next-line no-nested-ternary
        mobile
          ? [
              {
                leftSubText: '«',
                text: (
                  <Typography
                    variant='body1'
                    sx={{
                      color: theme.palette.primary.OfferSelected,
                      paddingLeft: '.5rem',
                      textDecoration: 'underline',
                    }}
                  >
                    Go back
                  </Typography>
                ),
                disable: onLoadingDisablecta,
                action: () => handleAlt(),
              },
            ]
          : prequal && prequaledFromBanner
          ? [
              {
                text: 'Try a different address',
                subText: '»',
                disable: onLoadingDisablecta,
                action: () => handleAltCta(),
              },
            ]
          : []
      }
      showLoader={showLoader}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      load={load}
    />
  );
};

export default LoginModal;
